import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Field, Form } from 'react-final-form';
import Select from 'react-select'
import { constructOptions, formatDateToDDMMYYYY, formatDateToYYYYMMDD } from '../../Utils/helper';
import { toast } from 'react-toastify';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { addCheque, getAllClients, getChequeDetailByID, getChequeType, getProvider } from '../../Redux/Actions/DashOptions';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../Common/Loader';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AddCheque = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { id } = useParams()
    const location = useLocation();
    const [loading, setLoading] = useState(false)
    const fileInputRef = useRef(null);

    const { editChequeData } = location.state || {};

    const getProviderData = useSelector((state) => state?.DashOptionsSlice?.listdata?.data) // get provider data for listing
    const getListingLoading = useSelector((state) => state?.DashOptionsSlice?.isLoading)    // get lisitng loading of provider
    const clientData = useSelector((state) => state?.DashOptionsSlice?.allClients?.data) // client list data 
    const clientListLoading = useSelector((state) => state?.DashOptionsSlice?.isLoading) // ckecking client list loading

    const getChequeListingType = useSelector((state) => state?.DashOptionsSlice?.getChequeTypeData?.data) // get data for listing
    const getChequeTypeData = useSelector((state) => state?.DashOptionsSlice?.isLoading)    // get lisitng loading

    const handleSubmit = (values, form) => {
        setLoading(true)
        const formData = new FormData();

        formData.append("cheque_number", values.chequeNumber);
        formData.append("provider_id", values.provider.value);
        formData.append("cheque_date", values.date);
        formData.append("amount", values.amount);
        formData.append("payer_name", values.payerName);
        formData.append("client_id", values.clientName?.value); // If using react-select
        formData.append("cheque_type_id", values.cheque_type_id?.value); // If using react-select
        formData.append("notes", values.notes || "");

        // File field
        if (values.cheque_path && typeof values.cheque_path !== 'string') {
            formData.append("cheque_path", values.cheque_path);
        }
        const onComplete = () => {
            setLoading(false);
            form.reset();
            fileInputRef.current.value = ""; // clear file input manually
        };
        if (!id) {
            dispatch(addCheque(formData)).then((res) => {
                setLoading(false)
                if (res?.payload?.data) {
                    toast.success(res?.payload?.message || 'Successfully added')
                } else {
                    toast.error('An error occured' || res?.payload?.message)
                }
                form.reset()
                onComplete()
                navigate('/dashboard/chequelist')

            })
        } else {
            dispatch(getChequeDetailByID({ id: editChequeData?.id, payload: formData })).then((res) => {
                setLoading(false)
                if (res?.payload?.data) {
                    toast.success(res?.payload?.message || 'Successfully updated')
                } else {
                    toast.error('An error occured')
                }
                form.reset()
                onComplete()
                navigate('/dashboard/chequelist')
                navigate('/dashboard/chequelist')

            })
        }

    };

    const handleBack = (e) => {
        e.preventDefault()
        if (id) {
            navigate("/dashboard/chequelist")
        } else {
            navigate("/dashboard");
        }
    };

    const validate = (values) => {
        const error = {};
        if (!values.date) {
            error.date = "Required"
        }
        if (!values.chequeNumber) {
            error.chequeNumber = "Required"
        }
        //  else if (!/^\d{10}$/.test(values.chequeNumber.replace(/-/g, ''))) {
        //     error.chequeNumber = "Number must be exactly 10 digits";
        // }
        if (!values.payerName) {
            error.payerName = "Required"
        }
        if (!values.provider) {
            error.provider = "Required"
        }
        if (!values.clientName) {
            error.clientName = "Required"
        }
        if (!values.amount) {
            error.amount = "Required"
        }

        return error
    }
    
    const initialValues = useMemo(() => {
        if (id && editChequeData) {
            return {
                chequeNumber: editChequeData?.cheque_number,
                date: formatDateToYYYYMMDD(editChequeData?.cheque_date),
                clientName: { value: editChequeData?.client?.id, label: editChequeData?.client?.name },
                amount: editChequeData?.amount,
                payerName: editChequeData?.payer_name,
                notes: editChequeData?.notes,
                cheque_path: editChequeData?.cheque_path,
                provider: { value: editChequeData?.client?.id, label: editChequeData?.client?.name },
                cheque_type_id: { value: editChequeData?.cheque_type?.id, label: editChequeData?.cheque_type?.name },
            }
        } return {
            chequeNumber: '',
            date: '',
            amount: '',
            payerName: '',
            clientName: '',
            notes: '',
            cheque_path: '',
            provider: '',
            cheque_type_id: ''
        }
    }, [editChequeData]);

    useEffect(() => {
        dispatch(getAllClients())
        dispatch(getProvider())
        dispatch(getChequeType())
    }, [id])

    return (
        <div className="min-h-screen flex items-start justify-center pt-9 sm:px-6 lg:px-8 bg-gray-50">
            {loading && <Loader />}
            <div className="bg-white shadow-2xl border border-gray-100 rounded-xl px-10 py-8 w-full max-w-5xl">
                <h2 className="text-3xl font-bold text-center text-indigo-700 mb-6">{id ? 'Update Cheque Detail' : 'Add New Cheque Detail'}</h2>
                <Form
                    initialValues={initialValues}
                    validate={validate}
                    onSubmit={handleSubmit}
                    render={({ handleSubmit, valid }) => (
                        <form onSubmit={(e) => {
                            if (!valid) {
                                toast.error('Please fill all the mandatory fields')
                            };
                            handleSubmit(e)
                        }} className="space-y-5">
                            <div className="grid grid-cols-2 gap-4">
                                <Field name="chequeNumber">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Cheque Number
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <input
                                                {...input}
                                                type="text"
                                                placeholder="Cheque Number"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                            />
                                            {meta.touched && meta.error && <span className='text-red-500 text-base font-bold ml-1'>{meta.error === "Number must be exactly 10 digits" ? meta.error : ""}</span>}
                                        </div>
                                    )}
                                </Field>
                                <Field name="date">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Date
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <input
                                                {...input}
                                                type="date"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                            />
                                        </div>
                                    )}
                                </Field>
                                <Field name="amount">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Amount $
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <input
                                                {...input}
                                                type="text"
                                                placeholder="$"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                            />
                                        </div>
                                    )}
                                </Field>
                                <Field name="payerName">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Payer Name
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <input
                                                {...input}
                                                type="text"
                                                placeholder="Payer Name"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                            />
                                        </div>
                                    )}
                                </Field>
                                <Field name="clientName">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Client
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <Select
                                                {...input}
                                                placeholder="Select CLient"
                                                options={constructOptions(
                                                    clientData?.filter(p => p?.status === 'active'),
                                                    "id",
                                                    "name",
                                                )}
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                onChange={(option) => input.onChange(option)}
                                                isLoading={clientListLoading}
                                            />
                                        </div>
                                    )}
                                </Field>
                                <Field name="provider">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Provider
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <Select
                                                {...input}
                                                placeholder="Select CLient"
                                                options={constructOptions(
                                                    getProviderData?.filter(p => p?.status === 'active'),
                                                    "id",
                                                    "name",
                                                )}
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                onChange={(option) => input.onChange(option)}
                                                isLoading={getListingLoading}
                                            />
                                        </div>
                                    )}
                                </Field>
                                <Field name="cheque_path">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Upload Cheque
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <input
                                                type="file"
                                                accept=".pdf,.jpg,.png"
                                                ref={fileInputRef} // 👈 here
                                                onChange={(e) => input.onChange(e.target.files[0])}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                            />
                                            {meta.touched && meta.error && (
                                                <span className="text-red-500 text-base font-bold ml-1">{meta.error}</span>
                                            )}
                                            {!input.value && editChequeData?.cheque_file && (
                                                <a
                                                    href={`${process.env.REACT_APP_LARAVEL_API_URL_DOCUMENT}/${editChequeData?.cheque_file}`}
                                                    download
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-blue-600 hover:underline flex items-center gap-2"
                                                >
                                                    <FontAwesomeIcon icon={faDownload} /> Uploaded Cheque
                                                </a>
                                            )}
                                        </div>
                                    )}
                                </Field>
                                <Field name="cheque_type_id">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Cheque Type
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                )}
                                            </label>
                                            <Select
                                                {...input}
                                                placeholder="Select Cheque Type"
                                                options={constructOptions(
                                                    getChequeListingType?.filter(p => p?.status === 'active'),
                                                    "id",
                                                    "name",
                                                )}
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                onChange={(option) => input.onChange(option)}
                                                isLoading={getChequeTypeData}
                                            />
                                        </div>
                                    )}
                                </Field>
                            </div>
                            <Field name="notes">
                                {({ input, meta }) => (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Note
                                        </label>
                                        <textarea
                                            {...input}
                                            type="text"
                                            placeholder="Note"
                                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                        />
                                    </div>
                                )}
                            </Field>

                            <div className="flex justify-end gap-4 pt-6">
                                <button
                                    type="button"
                                    onClick={handleBack}
                                    className="px-5 py-2 text-gray-700 bg-gray-200 hover:bg-gray-300 rounded-md transition"
                                >
                                    Back
                                </button>
                                <button
                                    type="submit"
                                    className="px-6 py-2 text-white bg-indigo-600 hover:bg-indigo-700 rounded-md shadow transition"
                                >
                                    {id ? "Update" : 'Submit'}
                                </button>
                            </div>
                        </form>
                    )}
                />
            </div>
        </div >
    );
};

export default AddCheque;
